"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disableIndexedDB = disableIndexedDB;
// just *accessing* indexedDB throws an exception in firefox with
// indexeddb disabled.
var indexedDB = void 0;
try {
  indexedDB = global.indexedDB;
} catch (e) {}

function disableIndexedDB() {
  indexedDB = undefined;
}

exports.default = indexedDB;
//# sourceMappingURL=IndexedDB.js.map